// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import JobBooking from './components/JobBooking';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<JobBooking />} />
      </Routes>
    </Router>
  );
}

export default App;
